import { Authenticator } from 'services/AuthService.jsx';
import { BASE_API_URL } from 'services/ConfigService.jsx';
import moment from 'moment';

import Log from 'services/Log.jsx';



const DataAPI = {
  test: function(callback) {
    API.GET("", (response) => {
      Log.debug("test fetching data layer");
      Log.debug(response);
      callback();
    });
  },
  getClients: function(params, callback) {
      API.POST("/app/v1/client", params, (response) => {
          callback(response);
      });
  },
  getMonthlyActiveClients: function(callback) {
      CACHE.GET("/app/v1/maclients", (response) => {
          callback(response);
      }, 300);
  },
  getMonthlyUsage: function(callback) {
      CACHE.GET("/app/v1/madata", (response) => {
          callback(response);
      }, 300);
  },
  getMetrics: function(params, callback) {
      API.POST("/app/v1/metric", params, (response) => {
          callback(response);
      });
  },
  getTags: function(params, callback) {
      API.POST("/app/v1/tag", params, (response) => {
          callback(response);
      });
  },
  getData: function(params, callback) {
      Log.debug("[DataApi - getData] params: " + JSON.stringify(params));
      API.POST("/app/v1/data", params, (response) => {
          callback(response);
      });
  },
  getPlans: function(callback) {
      Log.debug("[DataApi - getPlans]");
      API.GET("/app/v1/plans", (response) => {
          callback(response);
      });
  },
  getPlan: function(callback) {
      Log.debug("[DataApi - getPlan]");
      API.GET("/app/v1/plan", (response) => {
          callback(response);
      });
  },
  getBillingAgreement: function(params, callback) {
      Log.debug("[DataApi - getBillingAgreement] params: " + JSON.stringify(params));
      API.POST("/app/v1/billing", params, (response) => {
          callback(response);
      });
  }
};

const CACHE = {
  CLEAR: function() {
    localStorage.setItem("/app/v1/madata", "");
    localStorage.setItem("/app/v1/maclients", "");
    Log.debug("CLEARED CACHED");
  },
  GET: function(path, callback, ttl) {
    var cached = localStorage.getItem(path);
    Log.debug("CACHED DATA: ", cached);
    if (cached) {
      var obj = JSON.parse(cached);
      Log.debug("CACHED DATES", moment(obj.expires, 'MM/DD/YYYY HH:mm:ss').toDate(), new Date());
      if (moment(obj.expires, 'MM/DD/YYYY HH:mm:ss').toDate() > new Date()) {
        Log.debug("CACHED");
        callback(obj);
      } else {
        Log.debug("NOT CACHED 1");
        API.GET(path, (resp) => {
          Log.debug("CACHED RESP", resp);
          var obj = {
            data: {success:false}
          }
          if (resp.success) {
            var timestamp = moment(new Date());
            var expires = moment(new Date());
            expires.add(ttl, 's');
            obj = {
              timestamp: timestamp.format('MM/DD/YYYY HH:mm:ss'),
              expires: expires.format('MM/DD/YYYY HH:mm:ss'),
              data: resp
            };
            localStorage.setItem(path, JSON.stringify(obj));
          }
          callback(obj);
        });
      }
    } else {
      Log.debug("NOT CACHED 2");
      API.GET(path, (resp) => {
        Log.debug("CACHED RESP", resp);
        var obj = {
          data: {success:false}
        }
        if (resp.success) {
          var timestamp = moment(new Date());
          var expires = moment(new Date());
          expires.add(ttl, 's');
          obj = {
            timestamp: timestamp.format('MM/DD/YYYY HH:mm:ss'),
            expires: expires.format('MM/DD/YYYY HH:mm:ss'),
            data: resp
          };
          localStorage.setItem(path, JSON.stringify(obj));
        }
        callback(obj);
      });
    }
  }
}

const API = {
  GET: function(path, callback) {
    Log.debug("[DataService - GET] token: " + Authenticator.token);
    fetch(BASE_API_URL + path, {
      method: 'get',
      headers: {
       'Authorization': 'Bearer ' + Authenticator.token
      }
    })
    .then(function(response) {
      Log.debug(response);
      return response.json();
    })
    .then((response) => {
      if (response.success) {
        callback({success: true, data: response});
      } else {
        if (response.error && response.error.code) {
          if (response.error.code === 401) {
            Authenticator.signout(() => {
              window.location.href = "/";
            });
          }
        }
        callback({success: false, data: response});
      }
    })
    .catch((response) => {
      callback({success: false, data: response});
    });
  },
  POST: function(path, body, callback) {
    Log.debug("[DataService - POST] token: " + Authenticator.token);
    fetch(BASE_API_URL + path, {
      method: 'post',
      headers: {
       'Authorization': 'Bearer ' + Authenticator.token
      },
      body: JSON.stringify(body)
    })
    .then(function(response) {
        // Log.debug(JSON.stringify(response.json()));
      return response.json();
    })
    .then((response) => {
      if (response.success) {
        callback({success: true, data: response});
      } else {
        if (response.error && response.error.code) {
          if (response.error.code === 401) {
            Authenticator.signout(() => {
              window.location.href = "/";
            });
          }
        } else {
            callback({success: false, errors: response.errors});
        }
      }
    })
    .catch((response) => {
        Log.debug("[POST-ERROR] path: " + path + " request_body: " + JSON.stringify(body) + " response: " + JSON.stringify(response));
        Log.debug(response);
      callback({success: false, errors: ["Server Error"]});
    });
  },
  DELETE: function(path, callback) {
    Log.debug("[DataService - DELETE] token: " + Authenticator.token);
    fetch(BASE_API_URL + path, {
      method: 'delete',
      headers: {
       'Authorization': 'Bearer ' + Authenticator.token
      }
    })
    .then(function(response) {
        // Log.debug(JSON.stringify(response.json()));
      return response.json();
    })
    .then((response) => {
      if (response.success) {
        callback({success: true, data: response});
      } else {
        if (response.error && response.error.code) {
          if (response.error.code === 401) {
            Authenticator.signout(() => {
              window.location.href = "/";
            });
          }
        } else {
            callback({success: false, errors: response.errors});
        }
      }
    })
    .catch((response) => {
        Log.debug("[POST-ERROR] path: " + path + " response: " + JSON.stringify(response));
        Log.debug(response);
      callback({success: false, errors: ["Server Error"]});
    });
  },
  PUT: function(path, body, callback) {
    Log.debug("[DataService - PUT] token: " + Authenticator.token);
    fetch(BASE_API_URL + path, {
      method: 'put',
      headers: {
       'Authorization': 'Bearer ' + Authenticator.token
      },
      body: JSON.stringify(body)
    })
    .then(function(response) {
      return response.json();
    })
    .then((response) => {
      if (response.success) {
        callback({success: true, data: response});
      } else {
        if (response.error && response.error.code) {
          if (response.error.code === 401) {
            Authenticator.signout(() => {
              window.location.href = "/";
            });
          }
        } else {
            callback({success: false, errors: response.errors});
        }
      }
    })
    .catch((response) => {
      callback({success: false, errors: ["Server Error"]});
    });
  }
};

export { DataAPI, CACHE }



// WEBPACK FOOTER //
// ./src/services/DataService.jsx